import { FCW } from '../../types.ts';
import { Feedback, TransmissionStates, useTransmitFeedback } from './actions/useTransmitFeedback.ts';
import { SendFeedbackContext } from './SendFeedbackContext.ts';

export interface SendFeedbackApi {
  transmitStatus: TransmissionStates;
  transmitFeedback: (feedback: Feedback) => Promise<void>;
}

export const SendFeedbackProvider: FCW = ({ children }) => {
  const { transmitStatus, transmitFeedback } = useTransmitFeedback();

  return (
    <SendFeedbackContext.Provider
      value={{
        transmitStatus,
        transmitFeedback,
      }}
    >
      {children}
    </SendFeedbackContext.Provider>
  );
};
